/**
 * Takes a size name and returns a function that gets css value found in global themes
 * @param {string} size string name of property on global themes
 * @returns {function} function that takes styled-component props and returns css value
 */
export const ts = size => ({ theme: { sizing } }) => sizing[size];

/**
 * Takes a color name and returns a function that gets css value found in global themes
 * @param {string} color string name of property on global themes
 * @returns {function} function that takes styled-component props and returns css value
 */
export const tc = color => ({ theme: { colors } }) => colors[color];

/**
 * Takes a mediaSize name and returns a function that gets css value found in global themes
 * @param {string} mediaSize string name of property on global themes
 * @returns {function} function that takes styled-component props and returns css value
 */
export const tm = mediaSize => ({ theme: { media } }) => media[mediaSize];
